<div *ngIf="isNewVersionAvailable" class="upgrade d-flex justify-content-center align-items-center">
  {{ 'app.new-version' | translate }}
  <button (click)="upgrade()">{{ 'app.new-version.button' | translate }}</button>
</div>
<app-header
  [isShown]="
    isAuthenticated() && isBaseModelLoaded && !trialService.doesTrialExpired && (isWizardVisible | async) === false
  "
  (isBaseModalLoadedChange)="isBaseModelLoaded = false"
  [ngClass]="{ belowUpgradeMessage: isNewVersionAvailable }"
></app-header>
<app-side-menu
  [isShown]="isAuthenticated() && isBaseModelLoaded"
  [isWizardShown]="isWizardVisible | async"
></app-side-menu>

<div
  [ngClass]="{
    'print-no-margin': (isWizardVisible | async) === false,
    'content-wrapper': isAuthenticated() && isBaseModelLoaded && (isWizardVisible | async) === false,
    belowUpgradeMessageContent: isNewVersionAvailable,
  }"
>
  <ng-snotify></ng-snotify>
  <ng-template [ngIf]="isBaseModelLoaded && isAuthenticated() && !trialService.doesTrialExpired">
    <router-outlet></router-outlet>
  </ng-template>
  <ng-template [ngIf]="!isAuthenticated()">
    <app-login [ngClass]="{ belowUpgradeMessage: isNewVersionAvailable }"></app-login>
  </ng-template>
  <ng-template [ngIf]="!isBaseModelLoaded">
    <loading-spinner [isLoading]="true"></loading-spinner>
  </ng-template>

  <ng-template [ngIf]="trialService.isUserLoaded && trialService.shouldDisplayInfoModal">
    <div class="fake-modal-bg">
      <div class="fake-modal trial-info-modal">
        <button class="fake-modal-close" (click)="trialService.hideDailyModal()">
          <img src="../../../assets/img/close.svg" alt="time" />
        </button>
        <div class="trial-info-modal-icon">
          <img src="../../../assets/img/time.svg" alt="time" />
        </div>
        <div class="trial-info-modal-text">
          <div class="trial-info-modal-text-top">
            {{ 'trial.bottom-info-banner-row-a' | translate }}
            <strong
              >{{ trialService.trialDaysTillEnd }}
              {{
                trialService.trialDaysTillEnd === 1
                  ? ('trial.bottom-info-banner-row-a-day' | translate)
                  : trialService.trialDaysTillEnd >= 2 && trialService.trialDaysTillEnd <= 4
                    ? ('trial.bottom-info-banner-row-a-days2' | translate)
                    : ('trial.bottom-info-banner-row-a-days5' | translate)
              }}</strong
            >
          </div>
          <div class="trial-info-modal-text-bot">
            {{ 'trial.bottom-info-banner-row-b' | translate }}
            <a href="mailto:podpora@evidentist.cz">{{ 'trial.bottom-info-banner-row-contact' | translate }}</a>
          </div>
          <div class="trial-info-modal-text-btns">
            <btn
              [classes]="['btn', 'btn-first']"
              [label]="'trial.bottom-info-banner-button' | translate"
              (onEvent)="trialService.getFullVersion()"
            ></btn>
            <btn
              [classes]="['btn', 'btn-text-dark']"
              [label]="'trial.bottom-info-banner-button-later' | translate"
              (onEvent)="trialService.hideDailyModal()"
            ></btn>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="trialService.doesTrialExpired">
    <div class="fake-modal-bg">
      <div class="fake-modal trial-info-modal">
        <div class="trial-info-modal-icon">
          <img src="../../../assets/img/end_trial.svg" alt="time" />
        </div>
        <div class="trial-info-modal-text">
          <div class="trial-info-modal-text-top">
            {{ 'trial.info-banner-end-top' | translate }}
          </div>
          <div class="trial-info-modal-text-bot">
            {{ 'trial.info-banner-end-bottom' | translate }}
            <a href="mailto:podpora@evidentist.cz">{{ 'trial.bottom-info-banner-row-contact' | translate }}</a>
          </div>
          <div class="trial-info-modal-text-btns">
            <btn
              [classes]="['btn', 'btn-first']"
              [label]="'trial.bottom-info-banner-button' | translate"
              (onEvent)="trialService.getFullVersion()"
            ></btn>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="isLoading"> </ng-template>
</div>

<div
  class="loader-wrap"
  *ngIf="!this.isBaseModelLoaded"
  style="position: fixed; top: 0; left: 0; bottom: 0; right: 0; z-index: 999; background-color: #f4f7fc"
>
  <div class="background slide-top"></div>
  <div class="spinner d-flex flex-column justify-content-center slide-bottom">
    <div class="spinner-border text-primary align-self-end" role="status"></div>
  </div>
</div>

<style>
  .loader-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    overflow: hidden;
  }

  .background {
    background: transparent url('../assets/img/logo-evidentis.svg') 0% 0% no-repeat padding-box;
    width: 151px;
    height: 45px;
  }

  .empty {
    width: 151px;
    height: 30px;
  }

  /*ANIMATIONS*/

  .slide-top {
    -webkit-animation: slide-top 1.1s ease-in 300ms both;
    animation: slide-top 1.1s ease-in 300ms both;
  }
  @-webkit-keyframes slide-top {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
    100% {
      -webkit-transform: translateY(-1000px);
      transform: translateY(-1000px);
    }
  }
  @keyframes slide-top {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
    100% {
      -webkit-transform: translateY(-1000px);
      transform: translateY(-1000px);
    }
  }

  .slide-bottom {
    -webkit-animation: slide-bottom 1.1s ease-in 300ms both;
    animation: slide-bottom 1.1s ease-in 300ms both;
  }

  @-webkit-keyframes slide-bottom {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
    100% {
      -webkit-transform: translateY(1000px);
      transform: translateY(1000px);
    }
  }
  @keyframes slide-bottom {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
    100% {
      -webkit-transform: translateY(1000px);
      transform: translateY(1000px);
    }
  }
</style>
